export function isFirstLevelDomain(address: string | null) {
  if (!address) return false;
  const specialAddresses = ['/', '/en', '/zh'];
  return specialAddresses.includes(address);
}
